import { compose, mapProps, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTShareViaEmailForm from './BOTShareViaEmailForm'
import { quoteEmailData } from './actions'

const mapCommonPropsToRequestPayload = mapProps(({
  promotionId,
  emailType,
  ...props
}) => ({ requestPayload: { type: emailType }, ...props }))

// Note: The following forms share everything except of the @type and the parameter which
// refers to the page that we want to share. This is a TSA requirement so far.
// TODO:
// replace promotionId, storeId in the cartridge by just "id" so
// you can map them once in mapCommonPropsToRequestPayload above
// or even ask TSA to send a predefined requestPayload: { id, type } (or equivalent)

export const BOTEmailStoreDetails = compose(
  withType({ type: 'BOTEmailStoreDetails' }),
  mapCommonPropsToRequestPayload,
  mapProps(({ storeId, requestPayload, ...props }) =>
    ({ requestPayload: { ...requestPayload, id: [storeId]}, ...props }))
)(BOTShareViaEmailForm)

// TODO: update BOTEmailPromotionDetails and add the missing promotionId
export const BOTEmailPromotionDetails = compose(
  withType({ type: 'BOTEmailPromotionDetails' }),
  mapCommonPropsToRequestPayload,
  mapProps(({ promotionId, requestPayload, ...props }) =>
    ({ requestPayload: { ...requestPayload, id: [promotionId]}, ...props }))
)(BOTShareViaEmailForm)

// TODO: update BOTEmailQuote and add the missing quoteId (or equivalent)
export const BOTEmailQuote = compose(
  withType({ type: 'BOTEmailQuote' }),
  mapCommonPropsToRequestPayload,
  mapProps(({ quoteId, requestPayload, ...props }) =>
    ({ requestPayload: { ...requestPayload, id: [quoteId]}, ...props })),
  connect(null, { quoteEmailData }),
  lifecycle({
    UNSAFE_componentWillMount() {
      const { quoteEmailData, emailDescription, emailTitle, requestPayload, title } = this.props
      quoteEmailData({ emailDescription, emailTitle, requestPayload, title })
    }
  })
)(BOTShareViaEmailForm)

// TODO: update BOTEmailTireCompare and add the missing tireIds (or equivalent)
export const BOTEmailTireCompare = compose(
  withType({ type: 'BOTEmailTireCompare' }),
  mapCommonPropsToRequestPayload,
  mapProps(({ tireIds = [], requestPayload, ...props }) =>
    ({ requestPayload: { ...requestPayload, id: tireIds }, ...props }))
)(BOTShareViaEmailForm)
